import { useFiltersV2Select } from "PFApp/components/filters_v2";
import { generateApiFilters } from "PFApp/components/filters_v2/helpers/generate_api_filters";
import { LegacyGetProfilesCollection } from "PFApp/legacy_cv_export_flow";
import { useGrowlStoreActions } from "PFApp/stores/growl_store";
import { fetchExportProfiles } from "PFCore/services/export_profiles";
import { fetchProfiles } from "PFCore/services/profile";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { useProfilesPageContext } from "../../context";

// Legacy CV export flow copied from uat, used only when the cv_export_legacy_flow feature flag is ON.
// Meant to be removed together with the flag.
export const useLegacyCvExportProfilesCollection = () => {
  const { t } = useTranslation("legacyCvExport");
  const { order } = useProfilesPageContext();
  const { showGrowl: growl } = useGrowlStoreActions();
  const { mainFilters, childrenFilters, areChildrenOn } = useFiltersV2Select(
    "mainFilters",
    "childrenFilters",
    "areChildrenOn"
  );

  const getProfilesForExport = useCallback(
    (page = 1, perPage = 50) =>
      fetchProfiles({
        filters: generateApiFilters({ mainFilters, childrenFilters, areChildrenOn }),
        order: order ?? undefined,
        perPage,
        page
      })
        .then((data) => {
          const profileIdsToExport = data?.entries.map(({ profile }) => profile.id) ?? [];
          return fetchExportProfiles({
            profileIds: profileIdsToExport
          }).then((resp) => ({
            entries: resp.map((profile) => ({
              profile
            })),
            meta: { total: data.meta.total, page }
          }));
        })
        .catch(() => growl({ kind: "error", message: t("exportProfiles.errorFetchingExportData") })),
    [mainFilters, childrenFilters, order, areChildrenOn, growl, t]
  );

  return getProfilesForExport as LegacyGetProfilesCollection;
};
